import { createBrowserRouter, Outlet, replace } from 'react-router-dom';
import Login from 'pages/onboarding/Login';
import LanguageSelect from 'pages/onboarding/LanguageSelect';
import ConfirmData from 'pages/onboarding/ConfirmData';
import LayoutWithBG from 'pages/onboarding/components/LayoutWithBG';
import Account from 'pages/User';
import AssessmentList from 'pages/AssessmentList';
import MainLayout from 'layouts/MainLayout';
import AssessmentPage from 'pages/Assessment';
import ExaminationReceive from 'pages/ExaminationReceive';
import Register from 'pages/onboarding/Register';
import RegisterLayout from 'pages/onboarding/Register/RegisterLayout';
import ExaminationCheck from 'pages/ExaminationCheck';
import ROUTES from './constants/routes';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <MainLayout>
        <Outlet />
      </MainLayout>
    ),
    children: [
      {
        index: true,
        loader: async () => replace(ROUTES.ASSESSMENT),
      },
      {
        path: `${ROUTES.EXAMINATION_RECEIVE}/:examinationId`,
        element: <ExaminationReceive />,
      },
      {
        path: ROUTES.LOGIN,
        element: <Login />,
      },
      {
        path: ROUTES.ACCOUNT,
        element: <Account />,
      },
      {
        path: ROUTES.ASSESSMENT,
        children: [
          {
            index: true,
            element: <AssessmentList />,
          },
          {
            path: ':id',
            element: <AssessmentPage />,
          },
        ],
      },
    ],
  },
  {
    path: ROUTES.LANGUAGE_SELECT,
    element: (
      <LayoutWithBG>
        <LanguageSelect />
      </LayoutWithBG>
    ),
  },
  {
    path: ROUTES.CONFIRM_USER_DATA,
    element: (
      <LayoutWithBG>
        <ConfirmData />
      </LayoutWithBG>
    ),
  },
  {
    path: '/',
    element: (
      <RegisterLayout>
        <Outlet />
      </RegisterLayout>
    ),
    children: [
      {
        path: `${ROUTES.PUBLIC_EXAMINATION}/:examinationId`,
        element: <Register />,
      },
      {
        path: `${ROUTES.EXAMINATION}/:examinationId`,
        element: <ExaminationCheck />,
      },
    ],
  },
]);

export default router;
